// ------------------------------------------------------------------------------
// -*- mode: javascript; tab-width: 2; indent-tabs-mode: nil; -*-
// ------------------------------------------------------------------------------
// Sonant Live
//   A music tracker for the web.
//
// Copyright (c) 2011 Marcus Geelnard
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//    claim that you wrote the original software. If you use this software
//    in a product, an acknowledgment in the product documentation would be
//    appreciated but is not required.
//
// 2. Altered source versions must be plainly marked as such, and must not be
//    misrepresented as being the original software.
//
// 3. This notice may not be removed or altered from any source
//    distribution.

// Instrument presets

export default [
  {
    name: '====[LEADS]===='
  },
  {
    name: 'Softy',
    osc1_oct: 7,
    osc1_det: 0,
    osc1_detune: 0,
    osc1_xenv: 0,
    osc1_vol: 192,
    osc1_waveform: 2,
    osc2_oct: 7,
    osc2_det: 0,
    osc2_detune: 0,
    osc2_xenv: 0,
    osc2_vol: 201,
    osc2_waveform: 3,
    noise_fader: 0,
    env_attack: 100,
    env_sustain: 150,
    env_release: 13636,
    env_master: 191,
    fx_filter: 2,
    fx_freq: 5839,
    fx_resonance: 254,
    fx_delay_time: 6,
    fx_delay_amt: 121,
    fx_pan_freq: 6,
    fx_pan_amt: 147,
    lfo_osc1_freq: 0,
    lfo_fx_freq: 1,
    lfo_freq: 6,
    lfo_amt: 195,
    lfo_waveform: 0
  },
  {
    name: 'Classic 8-bit',
    osc1_oct: 7,
    osc1_det: 0,
    osc1_detune: 0,
    osc1_xenv: 0,
    osc1_vol: 192,
    osc1_waveform: 1,
    osc2_oct: 6,
    osc2_det: 0,
    osc2_detune: 9,
    osc2_xenv: 0,
    osc2_vol: 192,
    osc2_waveform: 1,
    noise_fader: 0,
    env_attack: 137,
    env_sustain: 2000,
    env_release: 4611,
    env_master: 192,
    fx_filter: 1,
    fx_freq: 982,
    fx_resonance: 89,
    fx_delay_time: 6,
    fx_delay_amt: 25,
    fx_pan_freq: 6,
    fx_pan_amt: 77,
    lfo_osc1_freq: 0,
    lfo_fx_freq: 1,
    lfo_freq: 3,
    lfo_amt: 69,
    lfo_waveform: 0
  },
  {
    name: 'Square',
    osc1_oct: 7,
    osc1_det: 0,
    osc1_detune: 0,
    osc1_xenv: 0,
    osc1_vol: 255,
    osc1_waveform: 1,
    osc2_oct: 7,
    osc2_det: 0,
    osc2_detune: 9,
    osc2_xenv: 0,
    osc2_vol: 154,
    osc2_waveform: 1,
    noise_fader: 0,
    env_attack: 197,
    env_sustain: 88,
    env_release: 10614,
    env_master: 45,
    fx_filter: 0,
    fx_freq: 11025,
    fx_resonance: 255,
    fx_delay_time: 2,
    fx_delay_amt: 146,
    fx_pan_freq: 3,
    fx_pan_amt: 47,
    lfo_osc1_freq: 0,
    lfo_fx_freq: 0,
    lfo_freq: 0,
    lfo_amt: 0,
    lfo_waveform: 0
  },
  {
    name: 'Bell',
    osc1_oct: 9,
    osc1_det: 0,
    osc1_detune: 0,
    osc1_xenv: 0,
    osc1_vol: 255,
    osc1_waveform: 0,
    osc2_oct: 9,
    osc2_det: 0,
    osc2_detune: 12,
    osc2_xenv: 0,
    osc2_vol: 255,
    osc2_waveform: 0,
    noise_fader: 0,
    env_attack: 100,
    env_sustain: 0,
    env_release: 14545,
    env_master: 70,
    fx_filter: 0,
    fx_freq: 0,
    fx_resonance: 240,
    fx_delay_time: 2,
    fx_delay_amt: 157,
    fx_pan_freq: 3,
    fx_pan_amt: 47,
    lfo_osc1_freq: 0,
    lfo_fx_freq: 0,
    lfo_freq: 0,
    lfo_amt: 0,
    lfo_waveform: 0
  },
  {
    name: '====[PADS]===='
  },
  {
    name: 'Base string',
    osc1_oct: 7,
    osc1_det: 0,
    osc1_detune: 0,
    osc1_xenv: 0,
    osc1_vol: 255,
    osc1_waveform: 2,
    osc2_oct: 8,
    osc2_det: 0,
    osc2_detune: 18,
    osc2_xenv: 0,
    osc2_vol: 255,
    osc2_waveform: 2,
    noise_fader: 0,
    env_attack: 100000,
    env_sustain: 56363,
    env_release: 100000,
    env_master: 199,
    fx_filter: 2,
    fx_freq: 200,
    fx_resonance: 254,
    fx_delay_time: 8,
    fx_delay_amt: 24,
    fx_pan_freq: 0,
    fx_pan_amt: 0,
    lfo_osc1_freq: 0,
    lfo_fx_freq: 0,
    lfo_freq: 0,
    lfo_amt: 0,
    lfo_waveform: 0
  },
  {
    name: '====[DRUMS]===='
  },
  {
    name: 'Bass drum 1',
    osc1_oct: 7,
    osc1_det: 0,
    osc1_detune: 0,
    osc1_xenv: 1,
    osc1_vol: 255,
    osc1_waveform: 0,
    osc2_oct: 7,
    osc2_det: 0,
    osc2_detune: 0,
    osc2_xenv: 1,
    osc2_vol: 255,
    osc2_waveform: 0,
    noise_fader: 0,
    env_attack: 50,
    env_sustain: 150,
    env_release: 4800,
    env_master: 200,
    fx_filter: 2,
    fx_freq: 600,
    fx_resonance: 254,
    fx_delay_time: 0,
    fx_delay_amt: 0,
    fx_pan_freq: 0,
    fx_pan_amt: 0,
    lfo_osc1_freq: 0,
    lfo_fx_freq: 0,
    lfo_freq: 0,
    lfo_amt: 0,
    lfo_waveform: 0
  },
  {
    name: 'Bass drum 2',
    osc1_oct: 7,
    osc1_det: 0,
    osc1_detune: 0,
    osc1_xenv: 1,
    osc1_vol: 255,
    osc1_waveform: 0,
    osc2_oct: 7,
    osc2_det: 0,
    osc2_detune: 0,
    osc2_xenv: 1,
    osc2_vol: 255,
    osc2_waveform: 0,
    noise_fader: 0,
    env_attack: 100,
    env_sustain: 0,
    env_release: 3636,
    env_master: 254,
    fx_filter: 2,
    fx_freq: 500,
    fx_resonance: 254,
    fx_delay_time: 0,
    fx_delay_amt: 27,
    fx_pan_freq: 0,
    fx_pan_amt: 0,
    lfo_osc1_freq: 0,
    lfo_fx_freq: 0,
    lfo_freq: 0,
    lfo_amt: 0,
    lfo_waveform: 0
  },
  {
    name: 'Bass drum 3',
    osc1_oct: 6,
    osc1_det: 0,
    osc1_detune: 0,
    osc1_xenv: 1,
    osc1_vol: 255,
    osc1_waveform: 0,
    osc2_oct: 6,
    osc2_det: 0,
    osc2_detune: 0,
    osc2_xenv: 1,
    osc2_vol: 255,
    osc2_waveform: 0,
    noise_fader: 14,
    env_attack: 50,
    env_sustain: 150,
    env_release: 8181,
    env_master: 161,
    fx_filter: 2,
    fx_freq: 5900,
    fx_resonance: 240,
    fx_delay_time: 6,
    fx_delay_amt: 66,
    fx_pan_freq: 0,
    fx_pan_amt: 0,
    lfo_osc1_freq: 0,
    lfo_fx_freq: 0,
    lfo_freq: 0,
    lfo_amt: 0,
    lfo_waveform: 0
  },
  {
    name: 'Snare 1',
    osc1_oct: 8,
    osc1_det: 0,
    osc1_detune: 0,
    osc1_xenv: 1,
    osc1_vol: 160,
    osc1_waveform: 0,
    osc2_oct: 8,
    osc2_det: 0,
    osc2_detune: 0,
    osc2_xenv: 1,
    osc2_vol: 160,
    osc2_waveform: 0,
    noise_fader: 210,
    env_attack: 50,
    env_sustain: 200,
    env_release: 6800,
    env_master: 160,
    fx_filter: 4,
    fx_freq: 11025,
    fx_resonance: 254,
    fx_delay_time: 6,
    fx_delay_amt: 32,
    fx_pan_freq: 5,
    fx_pan_amt: 61,
    lfo_osc1_freq: 0,
    lfo_fx_freq: 1,
    lfo_freq: 4,
    lfo_amt: 60,
    lfo_waveform: 0
  },
  {
    name: 'Snare 2',
    osc1_oct: 8,
    osc1_det: 0,
    osc1_detune: 0,
    osc1_xenv: 1,
    osc1_vol: 221,
    osc1_waveform: 0,
    osc2_oct: 8,
    osc2_det: 0,
    osc2_detune: 0,
    osc2_xenv: 1,
    osc2_vol: 210,
    osc2_waveform: 0,
    noise_fader: 255,
    env_attack: 50,
    env_sustain: 150,
    env_release: 15454,
    env_master: 229,
    fx_filter: 3,
    fx_freq: 11024,
    fx_resonance: 240,
    fx_delay_time: 6,
    fx_delay_amt: 24,
    fx_pan_freq: 0,
    fx_pan_amt: 20,
    lfo_osc1_freq: 0,
    lfo_fx_freq: 1,
    lfo_freq: 7,
    lfo_amt: 64,
    lfo_waveform: 0
  },
  {
    name: 'Hihat 1',
    osc1_oct: 8,
    osc1_det: 0,
    osc1_detune: 0,
    osc1_xenv: 1,
    osc1_vol: 82,
    osc1_waveform: 2,
    osc2_oct: 8,
    osc2_det: 0,
    osc2_detune: 0,
    osc2_xenv: 0,
    osc2_vol: 0,
    osc2_waveform: 0,
    noise_fader: 255,
    env_attack: 100,
    env_sustain: 0,
    env_release: 9090,
    env_master: 232,
    fx_filter: 3,
    fx_freq: 5200,
    fx_resonance: 63,
    fx_delay_time: 0,
    fx_delay_amt: 0,
    fx_pan_freq: 0,
    fx_pan_amt: 0,
    lfo_osc1_freq: 0,
    lfo_fx_freq: 0,
    lfo_freq: 0,
    lfo_amt: 0,
    lfo_waveform: 0
  },
  {
    name: 'Hihat 2',
    osc1_oct: 8,
    osc1_det: 0,
    osc1_detune: 0,
    osc1_xenv: 0,
    osc1_vol: 0,
    osc1_waveform: 0,
    osc2_oct: 8,
    osc2_det: 0,
    osc2_detune: 0,
    osc2_xenv: 0,
    osc2_vol: 0,
    osc2_waveform: 0,
    noise_fader: 60,
    env_attack: 50,
    env_sustain: 419,
    env_release: 4607,
    env_master: 130,
    fx_filter: 1,
    fx_freq: 10332,
    fx_resonance: 120,
    fx_delay_time: 4,
    fx_delay_amt: 16,
    fx_pan_freq: 5,
    fx_pan_amt: 108,
    lfo_osc1_freq: 0,
    lfo_fx_freq: 0,
    lfo_freq: 5,
    lfo_amt: 187,
    lfo_waveform: 0
  },
  {
    name: 'Smash',
    osc1_oct: 5,
    osc1_det: 0,
    osc1_detune: 0,
    osc1_xenv: 1,
    osc1_vol: 214,
    osc1_waveform: 0,
    osc2_oct: 5,
    osc2_det: 0,
    osc2_detune: 0,
    osc2_xenv: 1,
    osc2_vol: 204,
    osc2_waveform: 0,
    noise_fader: 229,
    env_attack: 50,
    env_sustain: 6363,
    env_release: 1818,
    env_master: 158,
    fx_filter: 3,
    fx_freq: 7924,
    fx_resonance: 240,
    fx_delay_time: 6,
    fx_delay_amt: 74,
    fx_pan_freq: 4,
    fx_pan_amt: 232,
    lfo_osc1_freq: 0,
    lfo_fx_freq: 1,
    lfo_freq: 6,
    lfo_amt: 231,
    lfo_waveform: 0
  },
  {
    name: 'Pipe hit',
    osc1_oct: 7,
    osc1_det: 0,
    osc1_detune: 0,
    osc1_xenv: 0,
    osc1_vol: 255,
    osc1_waveform: 3,
    osc2_oct: 8,
    osc2_det: 0,
    osc2_detune: 0,
    osc2_xenv: 0,
    osc2_vol: 255,
    osc2_waveform: 0,
    noise_fader: 127,
    env_attack: 22,
    env_sustain: 22,
    env_release: 2193,
    env_master: 255,
    fx_filter: 3,
    fx_freq: 4067,
    fx_resonance: 176,
    fx_delay_time: 4,
    fx_delay_amt: 12,
    fx_pan_freq: 2,
    fx_pan_amt: 84,
    lfo_osc1_freq: 0,
    lfo_fx_freq: 1,
    lfo_freq: 3,
    lfo_amt: 96,
    lfo_waveform: 0
  },
  {
    name: '====[F/X]===='
  },
  {
    name: 'Wind',
    osc1_oct: 8,
    osc1_det: 0,
    osc1_detune: 0,
    osc1_xenv: 0,
    osc1_vol: 0,
    osc1_waveform: 0,
    osc2_oct: 8,
    osc2_det: 0,
    osc2_detune: 0,
    osc2_xenv: 0,
    osc2_vol: 0,
    osc2_waveform: 0,
    noise_fader: 255,
    env_attack: 100000,
    env_sustain: 100000,
    env_release: 100000,
    env_master: 192,
    fx_filter: 2,
    fx_freq: 2500,
    fx_resonance: 16,
    fx_delay_time: 2,
    fx_delay_amt: 157,
    fx_pan_freq: 1,
    fx_pan_amt: 88,
    lfo_osc1_freq: 0,
    lfo_fx_freq: 1,
    lfo_freq: 2,
    lfo_amt: 51,
    lfo_waveform: 0
  }
]
